import styled from '@emotion/styled';

const CompactColumn = styled.td({
  width: '1rem',
});

export default CompactColumn;
